export default "__VITE_ASSET__CjVHUtEL__"